import { Alert } from "@mantine/core"

export const DataLoadingError = ({message, ...props}) => {
    return (
        <Alert title="Failed to refresh data" color="red" style={{flexShrink: 0}} {...props}>
            {message}
        </Alert>
    )
}